
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "../components/ui/button";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center p-8 bg-white rounded-lg shadow-md max-w-md">
        <h1 className="text-4xl font-bold mb-4 text-gray-800">404</h1>
        <p className="text-xl text-gray-600 mb-6">Oops! Page not found</p>
        
        <div className="space-y-4">
          <Button 
            onClick={() => navigate("/")} 
            variant="primary"
            className="w-full"
          >
            Return to Home
          </Button>
          
          <Button 
            onClick={() => navigate("/courses")} 
            variant="outline"
            className="w-full"
          >
            View Courses
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
